import "./music.css"

export default function Music(props) {

  return (
    <div
      class="music-container"
    >
      <div
        class="music-header"
      >
        <h1>Nic's Music</h1>

        <p>
          Here's a collection of my favorite music projects that I've been a part of!
        </p>
      </div>

      <div
        class="music-section"
      >
        <div
          class="music-section-inner"
        >
          <h4>
            Neighbor Dog
          </h4>

          <p>
            An emo / post hardcore band.  I sing and play guitar.
          </p>
          <iframe style={{
            border:0, width: "100%", height: "120px"
          }}
          src="https://bandcamp.com/EmbeddedPlayer/track=3384024259/size=large/bgcol=ffffff/linkcol=63b2cc/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://neighbordogmn.bandcamp.com/track/move-on">Move On by Neighbor Dog</a></iframe>
        </div>
      </div>


      <div
        class="music-section"
      >
        <div
          class="music-section-inner"
        >
          <h4>
            Two Blue Shoes
          </h4>

          <p>
            A math rock band.  I composed, recorded, and produced this record for fun in the winter.
          </p>
          <iframe style={{
            border:0, width: "100%", height: "120px"
          }}
          src="https://bandcamp.com/EmbeddedPlayer/album=1877343988/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://twoblueshoes.bandcamp.com/album/guitar-hero">Guitar Hero by Two Blue Shoes</a></iframe>
        </div>
      </div>


      <div
        class="music-section"
      >
        <div
          class="music-section-inner"
        >
          <h4>
            Oftener
          </h4>

          <p>
            An indie rock band.  I've been playing guitar and piano with this group for over seven years.
          </p>

          <iframe style={{borderRadius:"12px"}} src="https://open.spotify.com/embed/artist/3WEi6m5KEZSKZDSOfzhbjk?utm_source=generator" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
        </div>
      </div>
    </div>
  )
}